import { useCallback, useEffect } from 'react';
import useLocalize from '../../utils/hooks/useLocalize';
import { setDocumentTitle } from '../../utils/html';
import './DesktopScansContainer.scss';
import SavedPresetScansSection from './SavedPresetScansSection';
import ScanCriteriaSection from './ScanCriteriaSection';
import ScanResultsSection from './ScanResultsSection';

const DesktopScansContainer = () => {
  const localize = useLocalize();

  const setTitle = useCallback(() => {
    setDocumentTitle(localize('document.title.desktop.scans'));
  }, [localize]);

  useEffect(() => {
    setTitle();
  }, [localize, setTitle]);

  return (
    <>
      <div className="desktop-scans-container">
        <div className="desktop-scans-section">
          <div className="desktop-scans-content">
            <div className="desktop-scans-interface">
              <SavedPresetScansSection />
              <ScanCriteriaSection />
              <ScanResultsSection />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DesktopScansContainer;
